// extracted by mini-css-extract-plugin
export default {"container":"Score_container__wE+PS","titulo":"Score_titulo__UPxSF","pontos":"Score_pontos__zILNV"};